exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-distribuidores-js": () => import("./../../../src/pages/distribuidores.js" /* webpackChunkName: "component---src-pages-distribuidores-js" */),
  "component---src-pages-gana-js": () => import("./../../../src/pages/gana.js" /* webpackChunkName: "component---src-pages-gana-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

